<script>
import { sessionStorageClient } from '../../../libs'

export default {
  props: {
    selectedTabKey: String,
    tabs: Array,
    operadoraAnsId: String,
    prestadorId: String,
    status: String,
    responsavel: String,
    minDataPagamento: String,
    maxDataPagamento: String
  },
  computed: {
    selectedTabIndex () {
      const index = this.tabs.findIndex(tab => tab.key === this.$props.selectedTabKey)

      return index > 0 ? index : 0
    },
    query () {
      return {
        operadoraAnsId: this.operadoraAnsId || undefined,
        prestadorId: this.prestadorId || undefined,
        status: this.status || undefined,
        minDataPagamento: this.minDataPagamento || undefined,
        maxDataPagamento: this.maxDataPagamento || undefined,
        responsavel: this.responsavel || undefined
      }
    }
  },
  methods: {
    updateTab (key) {
      sessionStorageClient.removeItem('pagamentosFilters')
      sessionStorageClient.partialUpdate('pagamentosFilters', { tabKey: key === null ? undefined : key })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          tabKey: key === null ? undefined : key
        }
      })
    }
  }
}
</script>

<template>
  <v-tabs v-model="selectedTabIndex">
    <v-tab
      v-for="tab, index in tabs"
      :key="index"
      style="line-height: 1.5; font-size: 14px;"
      @click="updateTab(tab.key)"
    >
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>
